import React from 'react';
import { Icon, IconType } from '@chargify/icons';

import { IconContainer, StyledAnchor } from './Anchor.styles';

import { ComponentSize } from '../types';

export interface AnchorProps
  extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  /**
   * Anchor contents
   */
  label: string;
  /**
   * Component size
   */
  size?: ComponentSize;
  /**
   * Component left icon
   */
  iconLeft?: IconType;
  /**
   * Component right icon
   */
  iconRight?: IconType;
  /**
   * Component disabled state
   */
  disabled?: boolean;
  /**
   * Optional click handler
   */
  onClick?: () => void;
}

/**
- The Anchor component allows to easily create hyperlinks. It supports <a> HTML element attributes
**/
const Anchor = ({
  label,
  size = 'medium',
  iconLeft,
  iconRight,
  disabled = false,
  onClick,
  ...props
}: AnchorProps) => (
  <StyledAnchor
    size={size}
    onClick={() => (!disabled && onClick ? onClick() : null)}
    disabled={disabled}
    tabIndex={0}
    role="link"
    {...props}
  >
    {iconLeft && (
      <IconContainer iconSize={size}>
        <Icon fill="currentColor" type={iconLeft} />
      </IconContainer>
    )}
    {label}
    {iconRight && (
      <IconContainer iconSize={size}>
        <Icon fill="currentColor" type={iconRight} />
      </IconContainer>
    )}
  </StyledAnchor>
);

export default Anchor;
